import { createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { id: "projectExplorer" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h1", null, "AdvancedGUI", -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Your projects ")
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "material-icons" }, "upload", -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode("import project")
const _hoisted_6 = { class: "projectList" }
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { class: "material-icons" }, "add", -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("span", null, "Create new project", -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "openNote" }, "OPEN", -1)
const _hoisted_10 = { class: "bar" }
const _hoisted_11 = { class: "name" }
const _hoisted_12 = /*#__PURE__*/_createVNode("span", { class: "material-icons" }, "expand_more", -1)
const _hoisted_13 = {
  key: 0,
  class: "material-icons info"
}
const _hoisted_14 = { class: "absInfoBar" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_absolute_menu = _resolveComponent("absolute-menu")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("h2", null, [
      _hoisted_3,
      _createVNode("span", {
        class: "importBtn",
        onClick: _cache[1] || (_cache[1] = $event => (_ctx.triggerFileSelector()))
      }, [
        _hoisted_4,
        _hoisted_5
      ])
    ]),
    _createVNode("div", _hoisted_6, [
      _createVNode("div", {
        class: "card createNew",
        onClick: _cache[2] || (_cache[2] = (...args) => (_ctx.openNewProject(...args)))
      }, [
        _hoisted_7,
        _hoisted_8
      ]),
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.projects, (project) => {
        return (_openBlock(), _createBlock("div", {
          key: project.name,
          class: "card projectCard",
          onClick: $event => (_ctx.openProject(project)),
          ref: `proj#${project.name}`
        }, [
          _hoisted_9,
          _createVNode("div", _hoisted_10, [
            _createVNode("div", _hoisted_11, [
              _createVNode("h3", null, _toDisplayString(project.name), 1),
              _createVNode("span", null, _toDisplayString(((JSON.stringify(project).length * 2) / 1000 / 1000).toFixed(2) +
                " MB"), 1)
            ]),
            _createVNode("div", {
              class: "more",
              onClick: _withModifiers($event => (
              _ctx.$refs[`projMenu#${project.name}`].open($event.x, $event.y)
            ), ["stop"])
            }, [
              _hoisted_12,
              (project.version != _ctx.VERSION)
                ? (_openBlock(), _createBlock("span", _hoisted_13, "update"))
                : _createCommentVNode("", true)
            ], 8, ["onClick"])
          ]),
          _createVNode(_component_absolute_menu, {
            entries: _ctx.getActions(project),
            ref: `projMenu#${project.name}`
          }, null, 8, ["entries"])
        ], 8, ["onClick"]))
      }), 128 /* KEYED_FRAGMENT */))
    ]),
    _createVNode("div", _hoisted_14, [
      _createVNode("span", {
        class: "material-icons openLicensePrompt",
        onClick: _cache[3] || (_cache[3] = $event => (_ctx.licensePromptDoneAction = () => {}))
      }, "vpn_key")
    ]),
    _createVNode("input", {
      type: "file",
      ref: "fileDownload",
      accept: ".json",
      style: {"display":"none"},
      onChange: _cache[4] || (_cache[4] = $event => (_ctx.checkForUpload()))
    }, null, 544)
  ]))
}